// extracted by mini-css-extract-plugin
module.exports = {"recommendationList":"RecommendationList_recommendationList__YIkIM"};